import { Component, OnInit, ViewChild } from "@angular/core";
import { ItemService } from "../item.service";
import { HttpEventType } from "@angular/common/http";
import { ModalDirective } from "ngx-bootstrap";

@Component({
  selector: 'crm-provision-items',
  templateUrl: './provision-items.component.html',
  styleUrls: ['./provision-items.component.css']
})
export class ProvisionItemsComponent implements OnInit {

  progress: number;
  message: string;

  @ViewChild("provisionModal")
  provisionModal: ModalDirective;

  constructor(private readonly itemService: ItemService) { }

  ngOnInit() {
  }

  downloadCSVTemplate() {
    this.itemService.downloadCsvTemplate().subscribe(response => {

      const blob = new Blob([response], { type: "text/csv" });
      console.log(blob);
      const url = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.download = "ItemTemplate.csv";
      anchor.href = url;
      anchor.click();
      console.log(url);
      console.log(response);

    },
      err => { console.log(err); });
  }

  upload(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (let file of files)
      formData.append(file.name, file);

    this.itemService.uploadCsvTemplate(formData).subscribe(event => {
      if (event.type === HttpEventType.UploadProgress)
        this.progress = Math.round(100 * event.loaded / event.total);
      else if (event.type === HttpEventType.Response) {
        this.message = "uploaded success";
      }
    });
  }

}
